import React, { createContext } from 'react';

const MainContext = createContext({});
export { MainContext };
